import { render, staticRenderFns } from "./backLive.vue?vue&type=template&id=091d9cb4&scoped=true"
import script from "./backLive.vue?vue&type=script&lang=js"
export * from "./backLive.vue?vue&type=script&lang=js"
import style0 from "./backLive.vue?vue&type=style&index=0&id=091d9cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091d9cb4",
  null
  
)

export default component.exports